import React, { Component } from "react";

class CommonImagePreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            delayedVisible: false
        };
        this.delayTimeout = null;
    }

    handleLoad = () => {
        this.setState({ loaded: true }, () => {
            this.delayTimeout = setTimeout(() => {
                this.setState({ delayedVisible: true });
            }, 300);
        });
    };

    componentWillUnmount() {
        if (this.delayTimeout) clearTimeout(this.delayTimeout);
    }

    render() {
        const {
            width = '100%',
            height = '100%',
            alt = "",
            className = "",
            style = {},
            src = null,
            ...rest
        } = this.props;

        if (!src) return null;

        const sizeStyle = {
            width: typeof width === 'number' ? `${width}px` : width,
            height: typeof height === 'number' ? `${height}px` : height,
        };

        const baseStyle = {
            ...sizeStyle,
            borderRadius: "5%",
            objectFit: "cover",
            display: this.state.delayedVisible ? "block" : "none",
            ...style,
        };

        const placeholderStyle = {
            ...sizeStyle,
            // borderRadius: "50%",
            backgroundColor: "#EEE",
            border: "1px solid #DDD",
            display: this.state.delayedVisible ? "none" : "block",
        };

        return (
            <>
                <div style={placeholderStyle} />
                <img
                    src={src}
                    alt={alt}
                    onLoad={this.handleLoad}
                    className={className}
                    style={baseStyle}
                    {...rest}
                />
            </>
        );
    }
}

export default CommonImagePreview;
